import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User, AdminUser } from '../models/user.model';
import { HttpServices } from '../../../shared/services/http-service.service';
import { CookieService } from 'ngx-cookie-service';
import { RegisterType } from 'src/app/shared/models/enums.model';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    public currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    private currentUserSub: BehaviorSubject<User>;
    user: User = new User();
    cookieValue = '';
    public adminUser: BehaviorSubject<AdminUser>;
    constructor(private http: HttpServices,
        private cookieService: CookieService) {
        if (sessionStorage.getItem('AdminUserData') == null) {

            this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
            this.currentUser = this.currentUserSubject.asObservable();
        } else {
            this.adminUser = new BehaviorSubject<AdminUser>(JSON.parse(sessionStorage.getItem('AdminUserData')));
            this.user = new User();
            this.user.Email = this.adminUser.value.Email;
            this.user.UserName = this.adminUser.value.Email;
            this.user.FullName = this.adminUser.value.Title;
            this.user.IsAdmin = true;
            this.currentUserSubject = new BehaviorSubject<User>(this.user);
            this.currentUser = this.currentUserSubject.asObservable();

            // http.httpOptions.headers.set("CurrentAdminEmail", this.user.Email);
            // http.httpOptions.append("CurrentAdminEmail", this.user.Email);
        }

    }

    getSimulatedCurrentUser() {
        this.user = {
            Password: null,
            RegisterTypeId: 1,
            FullName: 'Admin',

            "UserId": "",
            "UserName": "galal.mohamed@suezcanal.gov.eg",
            Email: 'galal.mohamed@suezcanal.gov.eg',
            IsAdmin: true,

             /* "UserId": "",
              "UserName": "ahmed.badr@suezcanal.gov.eg",
              Email: 'ahmed.badr@suezcanal.gov.eg',
              IsAdmin: true,*/

            //   "UserId": "",
            //   "UserName": "m_alkhattab@suezcanal.gov.eg",
            //   Email: 'm_alkhattab@suezcanal.gov.eg',
            //   IsAdmin: true,

               /*"UserId":"54c1cc3f-6f6a-47dc-923d-9a79ff0c006f",
               Email: 'malkhattab83@gmail.com',
               "UserName": "malkhattab83@gmail.com",
               IsAdmin: false,*/

           /* "UserId": "f35e480e-9c90-4a04-ba6b-161e4aec6de3",
            "UserName": "ebooking.agenttest@gmail.com",
            Email: 'ebooking.agenttest@gmail.com',
            IsAdmin: false,*/

            //#endregion

            // FullName: 'agent',
            Address: 'test11111',
            CountryId: 1,
            Mobile: '+20033669988',
            Fax: '1111',
            Organization: 'test111111',
            ConfrimPassword: null,
            role: null,
            PortalUser: null,
            Agent: null,
            Supplier: null,
            recaptcha: null,
            RequestId: null,
            Phone1: '01282886910',
            Name: 'test',
            Phone: '01282886910',
            CompanyName: ''
        };
        return this.user;
    }
    public get currentUserValue(): User {
         return this.currentUserSubject.value;
       // return this.getSimulatedCurrentUser();
    }

    login(userLogin: User) {
        return this.http.post('Account/Login', userLogin)
            .pipe(map(user => {
                if (user.Success) {
                    const expire = new Date();
                    const time = Date.now() + ((3600 * 1000) * 2);
                    expire.setTime(time);

                    localStorage.setItem('currentUser', JSON.stringify(user.Data));
                    // this.cookieService.set( 'loggedInUser', JSON.stringify(user.Data) , );
                    //  this.cookieValue= this.cookieService.get('FedAuth');
                    //  if(this.cookieValue){
                    //    this.cookieService.set('FedAuth',this.cookieValue,expire);
                    //  }
                    this.currentUserSubject.next(user.Data);
                }

                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        return this.http.get('Account/Logout');
    }


}
